import classNames from "classnames";
import * as React from "react";

import { Close } from "@livechat/design-system-icons";
import { DesignToken, Icon, IconSource } from "@livechat/design-system-react-components";

import { FilterButton } from "components/filter/FilterButton";
import { ActionButton, Body, BoxContainer, CloseButton, Footer, Header, Title } from "components/filter/shared";
import { PopperContainer } from "components/popper-container";
import { withVar } from "themes/helpers";

interface IProps {
  title: string;
  selectedValuesLabel: React.ReactNode;
  icon: IconSource;
  removable: boolean;
  initiallyOpened: boolean;
  isValid?: boolean;
  onFilterRemove(): void;
  onCancel?(): void;
  onActionButtonClick(): void;
  actionButtonText: string;
  children: React.ReactNode;
}

export class Filter extends React.PureComponent<IProps> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  onFilterRemoveClick = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.preventDefault();
    event.stopPropagation();

    if (this.props.removable) {
      this.props.onFilterRemove();
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleCancel = () => {
    this.hideFilter(() => {
      if (this.props.onCancel) {
        this.props.onCancel();
      }
    });
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  hideFilter(cb = () => {}) {
    if (this.popperContainerRef.current) {
      this.popperContainerRef.current.toggle();
      cb();
    }
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleActionButtonClick = () => {
    // This deserves lifting up isOpen state to the
    // parent components.
    if (this.props.isValid) {
      this.hideFilter(() => {
        this.props.onActionButtonClick();
      });
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private handleFilterDropdownToggled = (isVisible: boolean) => {
    if (!isVisible && this.props.onCancel) {
      this.props.onCancel();
    }
  };

  private popperContainerRef: React.RefObject<PopperContainer> = React.createRef();

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { title, selectedValuesLabel, icon, removable, children, isValid } = this.props;

    return (
      <PopperContainer
        placement="bottom-start"
        offset="0,5"
        ref={this.popperContainerRef}
        initiallyVisible={this.props.initiallyOpened}
        onToggled={this.handleFilterDropdownToggled}
        content={
          <BoxContainer>
            <Header>
              <Icon source={icon} customColor={withVar(DesignToken.ActionPrimaryDefault)} />
              <Title>{title}</Title>
            </Header>
            <CloseButton onClick={this.handleCancel} type="button">
              <Icon source={Close} customColor={withVar(DesignToken.ActionPrimaryDefault)} />
            </CloseButton>
            <Body>{children}</Body>
            <Footer>
              <ActionButton
                className={classNames({ disabled: !isValid })}
                onClick={this.handleActionButtonClick}
                type="button"
              >
                {this.props.actionButtonText}
              </ActionButton>
            </Footer>
          </BoxContainer>
        }
      >
        <FilterButton
          title={title}
          icon={icon}
          removable={removable}
          selectedValuesLabel={selectedValuesLabel}
          onRemove={this.onFilterRemoveClick}
        />
      </PopperContainer>
    );
  }
}
